import { useAccount } from "wagmi";
import {
  Button,
  MBC,
  SmallSpinner,
  Typography,
} from "../../../../../../../components";
import { ConnectWalletButton } from "../../../../../../../features";
import { RewardInfo } from "./RewardInfo";
import { useClaimAllRewardsHandler } from "./useClaimAllRewardsHandler";

type ClaimAllRewardsBodyProps = {
  onClaimSuccess: () => void;
};

export const ClaimAllRewardsBody = ({
  onClaimSuccess,
}: ClaimAllRewardsBodyProps) => {
  const { isConnected } = useAccount();
  const { rewardsToClaim, submitClaim, isClaimInProgress, isRewardsLoading } =
    useClaimAllRewardsHandler(onClaimSuccess);

  const areThereRewardsToClaim = rewardsToClaim?.some(
    (reward) => reward.isAvailableToClaim
  );

  return (
    <MBC.InfoBox className="w-full">
      <Typography.Body>Rewards to claim:</Typography.Body>
      {rewardsToClaim === undefined || isRewardsLoading ? (
        <SmallSpinner />
      ) : (
        rewardsToClaim.map((rewardToClaim) => (
          <RewardInfo reward={rewardToClaim} />
        ))
      )}
      {isConnected ? (
        <Button.Primary
          onClick={submitClaim}
          disabled={isClaimInProgress || !areThereRewardsToClaim}
        >
          Claim
        </Button.Primary>
      ) : (
        <ConnectWalletButton small />
      )}

      <Typography.BodySmall>
        * During this action, your earned rewards will be transferred to your
        wallet
      </Typography.BodySmall>
    </MBC.InfoBox>
  );
};
